import React from "react";

export function Profile() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.684 7.90997C23.4545 7.65815 23.1295 7.5145 22.7887 7.5145H1.21125C0.870534 7.5145 0.545439 7.65815 0.31591 7.90997C0.086381 8.16179 -0.0263849 8.49875 0.00522833 8.83802L1.15651 21.2046C1.21452 21.8274 1.73705 22.3036 2.36253 22.3036H21.6374C22.2629 22.3036 22.7854 21.8273 22.8434 21.2046L23.9947 8.83802C24.0263 8.49875 23.9135 8.16179 23.684 7.90997ZM16.0399 19.7671C16.0391 19.767 16.0383 19.767 16.0375 19.7671H7.96255C7.29359 19.7671 6.75132 19.2247 6.75132 18.5559C6.75132 16.911 8.08949 15.5728 9.73435 15.5728H10.6036C9.70964 15.0789 9.10257 14.1266 9.10257 13.0351C9.10257 11.4374 10.4023 10.1376 12.0001 10.1376C13.5978 10.1376 14.8976 11.4373 14.8976 13.0351C14.8976 14.1266 14.2905 15.0789 13.3965 15.5728H14.2658C15.8771 15.5728 17.1941 16.8571 17.2471 18.4558C17.2498 18.4888 17.2513 18.5222 17.2513 18.5559C17.2511 19.2248 16.7089 19.7671 16.0399 19.7671ZM21.6697 5.25955C21.6697 5.76136 21.263 6.16797 20.7613 6.16797H3.23874C2.73705 6.16797 2.33031 5.76136 2.33031 5.25955C2.33031 4.75773 2.73705 4.35112 3.23874 4.35112H20.7613C21.263 4.35112 21.6697 4.75773 21.6697 5.25955ZM19.2715 1.90843C19.2715 2.41024 18.8647 2.81685 18.3631 2.81685H5.63698C5.13529 2.81685 4.72856 2.41024 4.72856 1.90843C4.72856 1.40661 5.13529 1 5.63698 1H18.3629C18.8647 1 19.2715 1.40661 19.2715 1.90843Z"
        fill="#29394D"
      />
    </svg>
  );
}
